export function formatInvoiceNumber(unformatted?: string): string {
  const formatted = unformatted?.match(/.{4}/g)?.join("-") ?? ""
  return formatted.length === 14 ? formatted : unformatted ?? ""
}
